import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css'; // design tokens (must load before other styles)
import './index.css';
import App from './App';

import { Provider } from 'react-redux'; //glue between redux and react
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';  // needs index.js file in the reducers folder.
import reduxThunk from 'redux-thunk';

// PWA service worker (autoUpdate). Register manually so we can poll for new
// builds on a timer — an always-on kiosk never navigates, so without this it
// would never pick up a new deploy. Every ~30 min it checks; autoUpdate then
// installs + reloads the screen on its own. (injectRegister is disabled in
// vite.config so this is the only registration.)
import { registerSW } from 'virtual:pwa-register';
// Belt-and-suspenders reload: when a NEW service worker takes control, reload so
// the fresh build shows without a power-cycle. Guarded so the first-ever install
// (no prior controller) doesn't trigger a reload, and so we only reload once.
if ('serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded || !hadController) return;
    reloaded = true;
    window.location.reload();
  });
}
registerSW({
  immediate: true,
  onRegisteredSW(swUrl, registration) {
    if (!registration) return;
    const check = () => registration.update().catch(() => {});
    // A single long timer can be deferred/suspended by the kiosk WebView, so
    // check more often AND whenever the screen regains focus or the network
    // comes back — any of these catches a new deploy.
    setInterval(check, 15 * 60 * 1000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
    window.addEventListener('online', check);
    check(); // once on load, too
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

root.render(
    <Provider store={store}>
      <App />
    </Provider>
);



